import React from 'react'
import * as Immutable from 'immutable';
import * as ImmutablePropTypes from 'react-immutable-proptypes';
import {connect} from 'react-redux';
import {Keys} from '../../model/constants/keys';
import ItemLstPanel from './../components/ItemLstPanel'

let CurrentItemsPage = (props) => {
    return (
        <ItemLstPanel {...props} />
    )
};

CurrentItemsPage.propTypes = {
    dispatch:React.PropTypes.func.isRequired,
    items:ImmutablePropTypes.map.isRequired,
    mutations:ImmutablePropTypes.map.isRequired,
    currentWorkSession:ImmutablePropTypes.map.isRequired,
};

const mapSateToProps = (state) => {
    return {
        mutations: state.mutationsState.get(Keys.EditorIds.ITEMS_PAGE, Immutable.Map()),
        items: state.itemsState.get(Keys.StoreSliceData.ITEMS),
        currentWorkSession: state.currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION,Immutable.Map()),
    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch:dispatch
        //doRefreshWorkSessions: () => dispatch(loadWorkSessions()),
        //doLoadWorkSession: (workSessionId) => dispatch(loadCurrentSession(workSessionId)),
        //doCreateAndLoadWorkSession: (templateId, onSuccess) => dispatch(createAndLoadNewSession(templateId, onSuccess)),
    }
};


export default connect(mapSateToProps, mapDispatchToProps)(CurrentItemsPage);



// WEBPACK FOOTER //
// ./src/ui/pages/CurrentItemsPage.js